import { useState, useEffect } from 'react'

const EMPTY_PREFERENCES = {}

const selectAllQuestions = sections => {
  const selection = {}
  sections.forEach(section => {
    selection[section.id] = section.questions.map(question => question.id)
  })
  return selection
}

const selectionFromPreferences = (sections, preferences) => {
  const selection = {}
  sections.forEach(section => {
    const sectionQuestions = section.questions
      .filter(question => preferences.question_ids.includes(question.id))
      .map(question => question.id)

    if (sectionQuestions.length > 0)
      selection[section.id] = sectionQuestions
  })
  return selection
}

const useExportPage = ({
  collectId,
  preferencesKey,
  savedPreferences = EMPTY_PREFERENCES,
  transformSections = null,
  buildInitialSelection = null
}) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const [ensemble, setEnsemble] = useState(null)
  const [selectedQuestions, setSelectedQuestions] = useState({})

  useEffect(() => {
    const headers = {
      'accept': 'application/json',
      'Content-Type': 'application/json'
    }

    fetch(`/collects/${collectId}.json`, { method: 'GET', headers })
      .then(response => {
        if (!response.ok)
          throw new Error('Erreur lors du chargement des données')

        return response.json()
      })
      .then(responseData => {
        const sections = transformSections?.(responseData.sections) ?? responseData.sections
        const preferences = savedPreferences?.[preferencesKey]
        const initialSelection = buildInitialSelection?.(sections)

        setData({ ...responseData, sections })
        setEnsemble(responseData.ensembles.find(item => item.id === responseData.ensemble_id))

        if (initialSelection)
          setSelectedQuestions(initialSelection)
        else if (preferences)
          setSelectedQuestions(selectionFromPreferences(sections, preferences))
        else
          setSelectedQuestions(selectAllQuestions(sections))

        setLoading(false)
      })
      .catch(err => {
        setError(err.message)
        setLoading(false)
      })
  }, [collectId, preferencesKey, savedPreferences, transformSections, buildInitialSelection])

  const totalSelectedQuestions = Object.values(selectedQuestions)
    .reduce((total, questions) => total + questions.length, 0)

  return {
    loading,
    error,
    data,
    ensemble,
    selectedQuestions,
    setSelectedQuestions,
    totalSelectedQuestions
  }
}

export default useExportPage
